import {FC} from "react";
import {ChartsAxisContentProps} from "@mui/x-charts/ChartsTooltip";
import {Paper, Stack, Typography} from "@mui/material";
import dayjs from "dayjs";
import {useSSTranslation} from "@/i18n/useSSTranslation";

export const CustomChartAxisTooltip: FC<ChartsAxisContentProps> = ({series, axisData, dataIndex}) => {
	const {t} = useSSTranslation();

	const lessonLabel = series[0].data[dataIndex] === 1 ? t("completed_lessons_column_lesson", "Lesson") : t("common_lessons", "Lessons");

	if (!axisData.x?.value) return null;

	const xValue = axisData.x.value;
	let dateLabel = "";

	if (Array.isArray(xValue) && xValue.length === 2) {
		const start = dayjs(xValue[0]).format("MMMM D");
		const end = dayjs(xValue[1]).format("MMMM D");
		dateLabel = `${start} - ${end}`;
	} else {
		dateLabel = dayjs(Array.isArray(xValue) ? xValue[0] : xValue).format("MMMM D, YYYY");
	}

	return (
		<Paper sx={{padding: "8px 12px 5px 12px", border: "none", backgroundColor: "grey.300"}}>
			<Stack sx={{justifyContent: "center", alignItems: "center"}}>
				<Typography color="primary">{`${series[0].data[dataIndex]} ${lessonLabel}`}</Typography>
				<Typography sx={{fontSize: "12px"}}>{dateLabel}</Typography>
			</Stack>
		</Paper>
	);
}

export default CustomChartAxisTooltip;